<template>
  <div class="container">
    <form class="needs-validation" id="seat-form" data-toggle="validator" novalidate>
      <div class>
        <div id="confirm-button-sticky" class="confirm-button-sticky" v-if="this.selectedSeats && this.selectedSeats.length > 0">
          <!-- -->

          <div class="confirm-booking-container">
            <div class="total-seats">Total seats: {{ this.selectedSeats.length }}</div>
            <div class="">
              <a class="href-btn btn-red btn-sm btn-primary confirm-seat-btn" v-on:click="confirmBooking()">
                <span>Confirm seats</span>
              </a>
            </div>
          </div>
        </div>
        <div class="main-list-container">
          <div class="view-seats-header">
            <div class="page-title col-12">
              <div class="row">
                <div class="col-12 text-center">
                  <h1 class="event-title text-center">Seats for {{ this.selectedEvent.title }}</h1>
                </div>
                <div class="col-12 text-center">
                  <small class="text-center">{{ this.remainingSeats }} seat<span v-if="this.remainingSeats > 1">s</span> remaining</small>
                </div>
              </div>
            </div>

            <div class="row seat-main-info">
              <div class="col-4 col-md-4">
                <span class="heading">Date</span>
                <span class="info">{{ this.selectedEvent.starts | dateFilter }}</span>
              </div>
              <div class="col-4 col-md-4">
                <span class="heading">From</span>
                <span class="info">{{ this.selectedEvent.starts | timeFilter }}</span>
              </div>
              <div class="col-4 col-md-4">
                <span class="heading">To</span>
                <span class="info">{{ this.selectedEvent.ends | timeFilter }}</span>
              </div>
            </div>
          </div>

          <div class="row seat-main-info">
            <div class="col-12">
              <div class="seat-status-container">
                <div class="seat-status">
                  <span class="seat-icon available"></span>
                  <span class="seat-icon-text">Available</span>
                </div>
                <div class="seat-status">
                  <span class="seat-icon reserved"></span>
                  <span class="seat-icon-text">Reserved</span>
                </div>
                <div class="seat-status">
                  <span class="seat-icon reserved-by-user"></span>
                  <span class="seat-icon-text">My reservations</span>
                </div>
                <div class="seat-status">
                  <span class="seat-icon in-progress"></span>
                  <span class="seat-icon-text">Selection</span>
                </div>
              </div>
            </div>
          </div>

          <div class="row seat-main-info text-center" v-if="this.message.length > 0">
            <div class="col-12 bold error">
              <p class="text-center error-text">{{ this.message }}</p>
            </div>
          </div>

          <div class="row" v-if="this.items && this.items.length > 0">
            <div class="col-12 max-seat-container">
              <!-- <button class="btn btn-primary" type="button" v-on:click="showToast(notifiationStatusCode)">show toast</button> -->
              <div class="seat-rows seat-container" v-for="(row, index) in itemsMatrix" :key="index">
                <div class="seat-item" v-for="(col, subIndex) in row" :key="subIndex">
                  <SeatItem @select="SEAT_SELECTED" :itemRow="index" :itemColumn="subIndex" :seatData="col" />
                </div>
              </div>

              <!-- <div class=""></div> -->

              <!-- <div v-for="row in rows" :key="row">
            <div v-for="col in maxItemsPerRow" :key="col">
              <SeatItem
                :seatData="getSeatItem(row, col)"
                v-if="row * maxItemsPerRow + col < items.length"/>
            </div>
              </div>-->
            </div>
          </div>
        </div>
        <div>
          <GenericDialog :showCloseButton="true" :showGenericDialog="showGenericDialog" @close="closeGenericDialog" :content="genericDialogContent">
            <div class="row">
              <div class="col-12">
                <Textbox id="seatData.firstname" :errors="this.errors" :value="seatData.firstname" @update="UPDATE_FIELD" label="Firstname" :lettersOnly="true" />
                <Textbox id="seatData.lastname" :errors="this.errors" :value="seatData.lastname" @update="UPDATE_FIELD" label="Lastname" :lettersOnly="true" />
                <Textbox id="seatData.contactNo" :errors="this.errors" :value="seatData.contactNo" @update="UPDATE_FIELD" label="Contact number" :numbersOnly="true" />
              </div>
              <div class="col-12">
                <div class="form-group row">
                  <div class="col-12 col-lg-4 col-form-label"></div>
                  <div class="col-12 col-lg-8">
                    <a class="href-btn btn default-btn-color btn-primary" v-on:click="ADD_SEAT_SELECTED()">
                      <span>Continue</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </GenericDialog>
          <GenericDialog :showCloseButton="true" :showGenericDialog="showGenericDeleteDialog" @close="closeGenericDeleteDialog" :content="genericDialogContent">
            <div class="row">
              <div class="col-12">
                <h3>Are you sure you want to remove this reservation?</h3>
                <p>{{ this.seatData.code }}</p>
              </div>
              <div class="col-12">
                <div class="form-group row">
                  <div class="col-12 col-lg-12r">
                    <div class="row center-align text-cente">
                      <div class="col-3">
                        <a class="href-btn btn-sm btn default-btn-color btn-primary" v-on:click="REMOVE_SEAT_SELECTED()">
                          <span>Remove</span>
                        </a>
                      </div>
                      <div class="col-3">
                        <a class="href-btn btn-sm btn default-btn-color btn-primary" v-on:click="closeGenericDeleteDialog()">
                          <span>Cancel</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </GenericDialog>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
import { EventsService } from "@/services/ApiService";
import GenericDialog from "@/components/controls/GenericDialog.vue";
import SeatItem from "@/components/controls/SeatItem.vue";

import Tooltip from "@/components/controls/Tooltip.vue";
import Textbox from "@/components/controls/Textbox.vue";
import rbValidator from "@/mixins/rbValidator";
import * as Validators from "@/utils/validators";
import * as FormFieldValidators from "@/utils/form-field-validators";
import commonMixin from "@/mixins/commonMixin";

import dateFilter from "@/filters/dateFilter";
import dateFilterFormatUKEventDisplay from "@/filters/dateFilterFormatUKEventDisplay";
import timeFilter from "@/filters/timeFilter";
import { toastNotificationComputed, toastNotificationMethods, toastNotificationMutations } from "@/state/helpers";

var validations = {
  "seatData.firstname": FormFieldValidators.firstname,
  "seatData.lastname": FormFieldValidators.lastname,
  "seatData.contactNo": FormFieldValidators.phone
};

export default {
  name: "ViewSeats",
  filters: { dateFilter, timeFilter, dateFilterFormatUKEventDisplay },
  mixins: [commonMixin, rbValidator],
  components: {
    SeatItem,
    Tooltip,
    Textbox,
    GenericDialog
  },
  data() {
    return {
      eventId: "",
      message: "",
      selectedEvent: {},
      items: [],
      rows: 0,
      maxItemsPerRow: 10,
      itemsMatrix: [],
      selectedSeats: [],
      seatData: {},
      errors: [],
      showGenericDialog: false,
      showGenericDeleteDialog: false,
      validations: validations,
      genericDialogContent: "",
      itemRow: 0,
      itemColumn: 0,
      totalBooked: 0,
      firstname: "",
      lastname: "",
      contactNo: "",
      notifiationStatusCode: 1,
      remainingSeats: 0
    };
  },
  methods: {
    ...toastNotificationMethods,
    ...toastNotificationMutations,
    // showToast(statusCode){
    //   this.SHOW_TOAST_NOTIFICATION({message: "Update successful... ", statusCode: statusCode});
    // },
    updateList(response) {
      this.message = "";
      if (typeof response.data !== "undefined") {
        var data = response.data;

        this.items = data.seats;
        this.totalBooked = data.totalBooked;
        this.firstname = data.firstname;
        this.lastname = data.lastname;
        this.contactNo = data.contactNo;
        this.remainingSeats = data.remainingSeats;
        //console.log("this seats: ", this.items);

        this.rows = Math.floor((this.items.length - 1) / this.maxItemsPerRow) + 1;
        this.itemsMatrix = this.getSeatMatrix(this.items, this.maxItemsPerRow);

        this.selectedSeats = [];
      }
    },
    seatsAlreadyBooked(response) {
      if (typeof response.errorMessage !== "undefined") {
        this.message = response.errorMessage;
        this.SHOW_TOAST_NOTIFICATION({ message: this.message, statusCode: this.notificationStatusCode.error });
      }
    },
    async getSeats(id) {
      var response = await EventsService.getSeats(id);
      if (typeof response !== "undefined" && response.success) {
        this.updateList(response);
      }
    },
    getSeatItem(row, col) {
      var data = this.items[row * this.maxItemsPerRow + col];
      return data;
    },
    getSeatMatrix(arr, cols) {
      return arr.reduce(function (rows, key, index) {
        return (index % cols == 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) && rows;
      }, []);
    },
    SEAT_SELECTED(userCanDelete, item, itemRow, itemColumn) {
      this.itemRow = itemRow;
      this.itemColumn = itemColumn;
      //console.log("index ", itemRow, "  sub index: ", itemColumn);
      if (typeof item !== "undefined" && item !== null) {
        if (item.userCanDelete) {
          this.seatData = item;
          //console.log("item.userCanDelete ", item.userCanDelete, " booking id: ", this.seatData.bookingId, " seat ", this.seatData.id);
          this.showGenericDeleteDialog = true;
        } else {
          if (item.seatStatus != 1) return;
          this.showGenericDialog = true;
          this.init("seat-form", this.validations);
          this.seatData = item;
          if (this.totalBooked === 0 && (this.selectedSeats === null || this.selectedSeats.length === 0)) {
            this.seatData.firstname = this.firstname;
            this.seatData.lastname = this.lastname;
            this.seatData.contactNo = this.contactNo;
          }
        }
      }

      //console.log("e: ", e, "  item: ", item);
    },
    ADD_SEAT_SELECTED(event) {
      this.validate("seat-form", this.validations);

      if (this.errors.length === 0) {
        if (typeof this.seatData !== "undefined" && typeof this.seatData.firstname !== "undefined" && this.selectedSeats !== null) {
          this.seatData.seatStatus = 4;
          this.selectedSeats.push(this.seatData);
          this.showGenericDialog = false;

          //var seatItem = this.itemsMatrix[this.itemRow][this.itemColumn];
          //console.log("data: ", seatItem);
          this.seatData = {};
        }

        return;
      }
    },
    hideAllDialogs() {
      this.showGenericDialog = false;
      this.showGenericDeleteDialog = false;
      this.resetValidation();
      this.seatData = {};
      this.scrollToTop("seat-form");
    },
    async REMOVE_SEAT_SELECTED() {
      var response = await EventsService.removeReservationByBookingIdAndSeatId(this.seatData.bookingId, this.seatData.id);

      if (typeof response !== "undefined" && response.success) {
        this.updateList(response);
        this.hideAllDialogs();
        this.SHOW_TOAST_NOTIFICATION({ message: "Update successful... ", statusCode: this.notificationStatusCode.success });
        return;
      }

      this.hideAllDialogs();
    },
    closeGenericDeleteDialog() {
      this.hideAllDialogs();
    },
    async confirmBooking() {
      if (this.eventId.length > 0 && this.selectedSeats.length > 0) {
        var response = await EventsService.bookSeatsForEvent({
          eventId: this.eventId,
          seats: this.selectedSeats
        });
        if (typeof response !== "undefined" && response.success) {
          this.updateList(response);
          this.SHOW_TOAST_NOTIFICATION({ message: "Reservation successful... ", statusCode: this.notificationStatusCode.success });
          return;
        }

        if (typeof response !== "undefined" && !response.success) {
          this.seatsAlreadyBooked(response);
          return;
        }
      }
    },
    closeAndContinue() {
      this.hideAllDialogs();
      this.$router.go(-1);
    },
    closeGenericDialog() {
      this.hideAllDialogs();
    },
    UPDATE_FIELD(key, value) {
      this.setFieldValue(this.seatData, key, value);
    }
  },
  computed: {},
  async mounted() {
    this.eventId = this.$route.params.id;
    this.selectedEvent = JSON.parse(sessionStorage.getItem("selected.event"));
    await this.getSeats(this.eventId);
  },
  created() {}
};
</script>

<style>
#seat-form {
  margin-bottom: 30px;
  padding-bottom: 20px;
}
#confirm-button-sticky {
  position: fixed;
  right: 10px;
  bottom: 95px;
  width: 160px;
  height: 76px;
  background-color: #0d1b4d;
  color: white !important;
  font-size: 1em !important;
  font-weight: normal !important;
  line-height: 1.5em !important;
  z-index: 1001;
}
.confirm-seat-btn {
  border: 2px solid #fff;
  border-radius: 0;
  margin-top: 6px;
}
.confirm-button-sticky {
  padding: 6px;
}
.confirm-button-sticky div {
  width: 100%;
  display: block;
  text-align: center;
}
</style>